module.exports = __webpack_public_path__ + "img/baoxiaomi-leg.3c6754ac.png";